<template>
    <component :is="tag" style="height: 100%">
        <slot
            :brief="brief"
            :contact="contact"
            :product-details="productDetails"
            :affiliate-links="affiliateLinks"
            :discount-codes="discountCodes"
            :brief-fields="briefFields"
            :is-preview="isPreview"
            :steps="steps"
            :current-step="currentStep"
            :errors="errors"
            :errorMessage="errorMessage"
            :is-loading="isLoading"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :complete-brief="completeBrief"
            :isLoading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :error-message="errorMessage"
            :restart-brief="restartBrief"
        />
    </component>
</template>

<script>
    import ActivationBriefMixin from './mixins/ActivationBriefMixin';
    import ContactsMixin from './mixins/ContactsMixin';
    import ActivationBriefStepsMixin from './mixins/ActivationBriefStepsMixin';
    import BaseActivationBriefStepMixin from './mixins/BaseActivationBriefStepMixin';
    import {ACTIVATION_BRIEF_STATUS_NONE} from '../../constants/activation-brief';
    import ActivationBriefProductsMixin from './mixins/ActivationBriefProductsMixin';

    export default {
        name:   'ActivationBriefProvider',
        mixins: [
            ActivationBriefMixin,
            ContactsMixin,
            ActivationBriefStepsMixin,
            BaseActivationBriefStepMixin,
            ActivationBriefProductsMixin,
        ],
        created() {
            this.isLoading = true;
            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(true),
                        this.loadAffiliateLinks(),
                        this.loadDiscountCodes(),
                        this.loadActivationBriefFields(),
                    ]).then(() => this.getOrderProductDetails(this.brief));
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    if (this.brief && this.brief.status !== ACTIVATION_BRIEF_STATUS_NONE) {
                        this.$router.push({name: 'v2.activation.brief.overview'});
                    }
                })
                .then(() => this.isLoading = false)
            ;
        },
    };
</script>
